import React from 'react';
import { Route, RoutePath, RoutesPaths, RoutesProvider, Switch, useRouterHelper } from '@shared/core';
import { CreateWedding } from '@apps/createWedding/CreateWedding';
import { TyingTheKnot } from '@apps/createWedding/routes/TyingTheKnot';

type RoutesNames = 'createwedding' | 'tying-the-knot';

export const routePaths: RoutesPaths<RoutesNames> = {
  createwedding: {
    path: '',
    goToPath: () => ''
  },
  'tying-the-knot': {
    path: 'tying-the-knot',
    goToPath: () => 'tying-the-knot'
  }
};

const RoutesCreateWedding = () => {
  const routeHelpers = useRouterHelper();

  const routes: Array<RoutePath<{}>> = [
    {
      path: routeHelpers.buildPath(routePaths.createwedding.path),
      component: () => <CreateWedding />
    },
    {
      path: routeHelpers.buildPath(routePaths['tying-the-knot'].path),
      component: () => <TyingTheKnot />
    }
  ];

  return (
    <Switch>
      {routes.map(route => (
        <Route exact key={route.path} path={route.path} render={route.component} />
      ))}
    </Switch>
  );
};

export const RouterCreateWedding: React.FC<{ appUrl: string }> = ({ appUrl }) => {
  return (
    <RoutesProvider appUrl={appUrl}>
      <RoutesCreateWedding />
    </RoutesProvider>
  );
};
